<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxLayout="column"
  class="sc-padding-div nvc-position-relative nvc-height-hundred"
  fxLayoutGap="15px"
>
  <div fxLayout="row">
    <h3 fxFlex="90" class="sc-heading">Payment method</h3>
    <div fxFlex="10" fxLayoutAlign="center center">
      <div fxFlex="5">
        <mat-icon
          class="ws-cursor-pointer nvc-close-main"
          (click)="closeDialog()"
          >close</mat-icon
        >
      </div>
    </div>
  </div>
  <!-- <mat-radio-group
    aria-label="Select a payment gateway"
    (change)="value = $event.value"
    fxLayout="column"
    fxLayoutGap="10px"
    style="font-size: 0.9rem"
  >
    <mat-radio-button *ngIf="dialogData.stripe" value="stripe">Stripe</mat-radio-button>
    <mat-radio-button *ngIf="dialogData.razorpay" value="razorpay">Razorpay</mat-radio-button>
    <mat-radio-button *ngIf="dialogData.paypal" value="paypal">Paypal</mat-radio-button>
    <mat-radio-button *ngIf="dialogData.cod" value="cod">Cash on Delivery</mat-radio-button>
  </mat-radio-group> -->
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1.5rem">
    <div
      class="sc-option-select ws-cursor-pointer"
      fxLayoutAlign="center center"
      [ngClass]="{
        'sc-select-option': value === 'razorpay'
      }"
      (click)="selectGateway('razorpay')"
    >
      <img src="{{ razorpay }}" alt="razorpay" />
    </div>
    <div
      class="sc-option-select ws-cursor-pointer"
      fxLayoutAlign="center center"
      [ngClass]="{
        'sc-select-option': value === 'stripe'
      }"
      (click)="selectGateway('stripe')"
    >
      <img src="{{ stripe }}" alt="stripe" />
    </div>
  </div>
  <div
    class="sc-proceed-button nvc-position-absolute"
    fxLayout
    fxLayoutAlign="center center"
  >
    <button
      (click)="emitSelection()"
      class="sc-button-enable ws-cursor-pointer"
      [ngClass]="{
        'sc-button-disable ws-no-cursor-pointer': value.length < 1
      }"
    >
      Proceed to pay
    </button>
  </div>
</div>
